import { render, staticRenderFns } from "./tianjinIndex.vue?vue&type=template&id=5e241358&scoped=true"
import script from "./tianjinIndex.vue?vue&type=script&lang=js"
export * from "./tianjinIndex.vue?vue&type=script&lang=js"
import style0 from "./tianjinIndex.vue?vue&type=style&index=0&id=5e241358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e241358",
  null
  
)

export default component.exports